const Splash = () => {

    return(
        <section className="Splash" >
            <img className="Splash-Top" src="/Graphics/Splash-Top-Fx.png" alt="Splash Animation" />
            <img className="Splash-Bottom" src="/Graphics/Splash-Bottom-Fx.png" alt="Splash Animation" />
            <img className="Splash-Animation" src="/Graphics/Splash-Animation.gif" alt="Splash Animation" />
        </section>
    );

};

export default Splash;